import { ChevronRight } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { formatAnyName } from "@/utils/text";
import { Flex, Text } from "@radix-ui/themes";
import { Link } from "react-router-dom";
import { useAuth } from "@/providers/AuthProvider";

interface BreadcrumbProps {
  className?: string;
}

export function Breadcrumb({ className = "" }: BreadcrumbProps) {
  const pathname = useLocation().pathname;
  const { currentTenant, safeNavigate } = useAuth();

  const breadcrumbs = useMemo(() => {
    const segments = pathname
      .split("/")
      .filter(Boolean)
      .filter((segment, index, arr) => {
        // Skip 'org' and the tenant ID that follows it
        if (segment === "org" || (index > 0 && arr[index - 1] === "org")) {
          return false;
        }
        return true;
      });

    return segments.map((segment, index) => {
      const path = `/${segments.slice(0, index + 1).join("/")}`;
      const label = segment
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return { path, label };
    });
  }, [pathname]);

  if (pathname === "/") return null;

  return (
    <Flex gap="2" align="center" className={className}>
      <Link to="/">
        <img
          src="/assets/anythink-icon-03.svg"
          alt="Home"
          width={16}
          height={16}
          className="dark:invert"
        />
      </Link>

      {breadcrumbs.map((breadcrumb, index) => (
        <Flex key={breadcrumb.path} align="center">
          <ChevronRight
            style={{ width: 16, height: 16, margin: "0 8px", opacity: 0.5 }}
          />
          {index === breadcrumbs.length - 1 ? (
            <Text size="2" weight="medium">
              {formatAnyName(breadcrumb.label)}
            </Text>
          ) : (
            <Link
              to={`/org/${currentTenant?.id}${breadcrumb.path}`}
              onClick={(e) => {
                e.preventDefault();
                safeNavigate(breadcrumb.path);
              }}
            >
              <Text size="2" color="gray">
                {formatAnyName(breadcrumb.label)}
              </Text>
            </Link>
          )}
        </Flex>
      ))}
    </Flex>
  );
}
